import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js';
const url = gapi + "collages";


const collages = {
  namespaced: true,
  state: {
    msg:null,
    collagesAll: [],
    city:[],
    district:[]
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.collagesAll;
    },
    getTodoById: (state) => (id) => {
      return state.collagesAll.find((todo) => todo.id == id);
    },
    getMsg: (state) => {
      return state.msg;
    }
  },
  mutations: {
    SET_DATA(state, data) {
      state.collagesAll = data;
    },

    ADD_DATA(state, data) {
      this.city = str.state.cities.find((todo) => todo.id == data.City);
      this.district = str.state.districts.find((todo) => todo.id == data.District);
      data.cName = this.city.cName;
      data.dName = this.district.dName;
      state.collagesAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.collagesAll.findIndex((t) => t.id === data.id);
      this.city = str.state.cities.find((todo) => todo.id == data.City);
      this.district = str.state.districts.find((todo) => todo.id == data.District);
      var dts = {
        id : data.id ,
        collageName: data.collageName,
        collageSite: data.collageSite,
        City: data.City,
        District: data.District,
        cName: this.city.cName,
        dName: this.district.dName

                     }
      if (index !== -1) {
        state.collagesAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.collagesAll = state.collagesAll.filter((t) => data.id !== t.id);
    },STATE_CRUD(state,data){
      var num = data;
      num = num.toString().replace( /^\D+/g, '');
      state.msg = num;
    }
  }
  ,
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{
          Authorization: str.state.token
        })
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url,data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
          
        })
        .catch((error) => {
        console.log(error)
      
      });
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
   async  updateData({ commit }, data) {

      var app = url + "/" + data.id;
      await axios
        .put(app,data,{headers:{Authorization: str.state.token}})
        .then((res)=>{
         
          commit("UPDATE_DATA", data)
          commit("STATE_CRUD", res.data.status)
        
        })
        .catch((error) =>{ console.log(error)
         
         
          commit("STATE_CRUD", error)
      });
    
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default collages;
